/**
 * Laadt aanbevelingen voor de cart drawer en zet ze in een horizontale strook met pijltjes.
 * De HTML komt uit sections/mm-cart-cross-sell.liquid (Section Rendering API).
 */
const cache = new Map();

class MmCartCrossSell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.#load();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  async #load() {
    const url = this.dataset.url;
    const track = this.querySelector('[data-mm-cross-sell-track]');
    if (!url || !track) return;

    try {
      let html = cache.get(url);
      if (!html) {
        const response = await fetch(url);
        if (!response.ok) return;
        html = await response.text();
        cache.set(url, html);
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const list = doc.querySelector('.mm-cross-sell__list');
      if (!list) return;

      if (!list.children.length) return;

      track.replaceChildren(list);
      this.hidden = false;
    } catch (error) {
      // Aanbevelingen zijn optioneel; bij een fout blijft het blok verborgen
    }
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const arrow = event.target.closest('.mm-cross-sell__arrow');
    if (!arrow) return;
    const list = this.querySelector('.mm-cross-sell__list');
    if (!list) return;
    const direction = Number(arrow.getAttribute('data-direction')) || 1;
    list.scrollBy({ left: direction * list.clientWidth, behavior: 'smooth' });
  };
}

if (!customElements.get('mm-cart-cross-sell')) {
  customElements.define('mm-cart-cross-sell', MmCartCrossSell);
}
